import { __awaiter } from "tslib";
import apis from '@/requests';
export const Options = {
    body: {
        farmId: []
    },
    refs: {
        days: '[calendarDay]'
    },
    loaders: {
        fetch(self, done, fail, { farmId, yyyymm }) {
            return __awaiter(this, void 0, void 0, function* () {
                try {
                    let days = yield apis.calendar.list(farmId, yyyymm);
                    self.$init({
                        farmId,
                        days: days.items
                    });
                    done();
                }
                catch (error) {
                    fail(error);
                }
            });
        }
    },
    list: {
        key: model => model.farmId
    }
};
